import { useTranslation } from 'react-i18next';

//TODO HTTPS Validation?
import { InternalPage } from 'theSource/components';
import { ThirdPartyLicenses } from './components';
import { ROUTES } from 'theSource/app/routes';
import { BackLink } from 'enrollment/components';

export const LicensesPage = () => {
  const { t } = useTranslation('pages.thirdPartyLicenses');

  return (
    <>
      <BackLink
        underline={false}
        testId="back-button"
        className="mb-4"
        defaultPath={`${ROUTES.public.legalDocuments.path}/`}
      />
      <InternalPage testId="licenses-page" title={t('title')}>
        <ThirdPartyLicenses />
      </InternalPage>
    </>
  );
};
